import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Button } from 'ksnm-common-ui/lib/Button';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Select } from 'ksnm-common-ui/lib/Select';
import { sortBy, uniqBy } from 'lodash-es';

import { reportPeriodsStore } from '@stores/dictionaryStores/reportPeriodsStore';
import { reportVersionsStore } from '@stores/dictionaryStores/reportVersion/reportVersionsStore';

import styles from './Filter.module.scss';

export const Filter = observer((): JSX.Element => {
  const { reportVersions, setFilters, filters, setSelectNode, setSelectedKeys } = reportVersionsStore;
  const { groupInPeriods } = reportPeriodsStore;

  const { reportGroup, reportType } = filters;

  const onClear = useCallback(() => {
    setFilters({});
    setSelectNode(null);
    setSelectedKeys([]);
  }, [setFilters, setSelectNode, setSelectedKeys]);

  const onChangeReportGroup = useCallback(
    (v) => {
      setFilters({ ...filters, reportGroup: v });
      setSelectNode(null);
      setSelectedKeys([]);
    },
    [filters, setFilters, setSelectNode, setSelectedKeys],
  );

  const onChangeReportType = useCallback(
    (v) => {
      setFilters({ ...filters, reportType: v });
      setSelectNode(null);
      setSelectedKeys([]);
    },
    [filters, setFilters, setSelectNode, setSelectedKeys],
  );

  const reportGroupItems = useMemo(
    () =>
      sortBy(
        uniqBy(
          reportVersions.filter((item) => {
            if (reportType && item.reportTypeCode !== reportType) {
              return false;
            }
            return !!item.reportGroupCode && groupInPeriods.includes(item.reportGroupCode);
          }),
          'reportGroupCode',
        ).map((group) => ({
          id: group.reportGroupCode,
          name: `${group.reportGroupCode} - ${group.reportGroupName}`,
        })),
        'name',
      ),
    [groupInPeriods, reportType, reportVersions],
  );

  const reportTypeItems = useMemo(
    () =>
      sortBy(
        uniqBy(
          reportVersions.filter((item) => {
            if (reportGroup && item.reportGroupCode !== reportGroup) return false;
            return !!item.reportTypeCode && groupInPeriods.includes(item.reportGroupCode);
          }),
          'reportTypeCode',
        ).map((group) => ({
          id: group.reportTypeCode,
          name: `${group.reportTypeCode} - ${group.reportTypeName}`,
        })),
        'name',
      ),
    [groupInPeriods, reportGroup, reportVersions],
  );

  return (
    <div className={styles.designFilters}>
      <div className={styles.items}>
        <Select
          items={reportGroupItems}
          placeholder="Группа отчетов"
          value={reportGroup}
          onChange={onChangeReportGroup}
          size="small"
          showSearch
          className={styles.select}
        />
        <Select
          items={reportTypeItems}
          placeholder="Тип отчета"
          value={reportType}
          onChange={onChangeReportType}
          size="small"
          showSearch
          className={styles.select}
        />
      </div>

      <Button onClick={onClear} disabled={!(reportGroup || reportType)} icon={<Icon name="stop" />}>
        Сбросить фильтры
      </Button>
    </div>
  );
});
